import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { GuideTopicPage } from '@/features/guide';

export const Route = createFileRoute('/guide/$topic')({
  component: RouteComponent,
});

function RouteComponent(): ReactElement {
  const { topic } = Route.useParams();
  return <GuideTopicPage topicId={topic} />;
}
